import {z} from '@hono/zod-openapi';

import {priceReportArgumentFactSchema} from './PriceReportArgumentFactSchema';
import {priceReportArgumentSetSchema} from './PriceReportArgumentSetSchema';
import {priceReportArgumentsLocaleSchema} from './PriceReportArgumentsLocaleSchema';
import {priceReportArgumentsStatusSchema} from './PriceReportArgumentsStatusSchema';

export const priceReportArgumentsResponseSchema = z
  .object({
    status: priceReportArgumentsStatusSchema,
    reportId: z.string(),
    locale: priceReportArgumentsLocaleSchema,
    promptVersion: z.string(),
    model: z.string().nullable(),
    generatedAt: z.string().nullable(),
    facts: z.array(priceReportArgumentFactSchema),
    selling: priceReportArgumentSetSchema.nullable(),
    buying: priceReportArgumentSetSchema.nullable(),
  })
  .openapi('PriceReportArgumentsResponse');

export type PriceReportArgumentsResponse = z.infer<typeof priceReportArgumentsResponseSchema>;
